<script setup lang="ts">
import { Menu, MenuButton } from '@headlessui/vue'
import IconGlobe from '~/assets/icons/icon-globe.svg?component'

const {
  iconSize = 16,
  textClass = 'text-gray-800 text-caption font-medium',
  openDirection = 'up',
  hideTextBelow840 = false,
} = defineProps<{
  iconSize?: number
  textClass?: string
  openDirection?: 'up' | 'down'
  hideTextBelow840?: boolean
}>()

defineEmits<{
  navbarClose: []
}>()

const route = useRoute()
const { locale, t } = useI18n()

const getShortLocaleLabel = (localeCode: string): string => {
  const translationKey = `general.languages.shortCodes.${localeCode}` as any
  return t(translationKey) || localeCode.toUpperCase()
}

const currentLocaleShort = computed(() => getShortLocaleLabel(locale.value))
</script>

<template>
  <div class="flex items-center">
    <Menu v-slot="{ open }" as="div" class="relative inline-block">
      <MenuButton :class="['flex items-center gap-2', textClass]">
        <IconGlobe
          :size="iconSize"
          class="text-stone-700 stroke-stone-700 stroke-width-1.67"
        />
        <span :class="{ 'hidden min-[840px]:block': hideTextBelow840 }">{{
          currentLocaleShort
        }}</span>
      </MenuButton>
      <DropdownLocaleMenuItems
        :key="route.path"
        :open="open"
        :open-direction="openDirection"
        @locale-selected="$emit('navbarClose')"
      />
    </Menu>
  </div>
</template>
